<div class="relative">
  @if (previewUri() && !hasLoadError()) {
    <div class="relative aspect-4/3 w-full overflow-hidden rounded-lg">
      @if (!isLoaded()) {
        <pxc-image-loading class="absolute inset-0" />
      }
      <img
        class="absolute inset-0 size-full select-none object-cover"
        data-testid="image"
        draggable="false"
        pxcImageLoad
        [alt]="sadmEntity() | sadmEntityName: sadmType()"
        [src]="previewUri()"
        (loadError)="onImageLoadingError()"
        (loadSuccess)="onImageLoaded()" />
    </div>
  }
  @if (!previewUri() || hasLoadError()) {
    <pxc-image-broken class="aspect-4/3 h-auto! rounded-lg" />
  }
  @if (sadmEntity().isArchived) {
    <pxc-archived-badge class="absolute left-2 top-2" data-testid="archived-badge" />
  }
  <span class="absolute bottom-2 right-2">
    <span appearance="brand" data-testid="analysis-badge" iconStart="@tui.chart-line" size="l" tuiBadge></span>
  </span>
</div>
<p class="mt-3 select-none text-base font-medium leading-tight text-text-primary">
  {{ sadmEntity() | sadmEntityName }}
</p>
@let hasEntityType = !!sadmType() && sadmEntity().patientEntityIndex !== undefined;
@if (sadmEntity().sadmClient?.name || hasEntityType) {
  <p class="mt-1 select-none text-sm text-text-tertiary" data-testid="subtitle">
    @if (sadmEntity().sadmClient?.name; as sadmClientName) {
      {{ sadmClientName }}
      @if (hasEntityType) {
        - {{ sadmEntity() | sadmEntityType: sadmType() }}
      }
    } @else {
      {{ sadmEntity() | sadmEntityType: sadmType() }}
    }
  </p>
}
@if (sadmEntity().createdOn) {
  <p class="mt-1 select-none text-sm text-text-quaternary" data-testid="date">
    {{ sadmEntity().createdOn | date }}
  </p>
}
